module.exports = __webpack_public_path__ + "img/login_icon.1413b858.svg";